import { Component, Input, OnInit } from '@angular/core';
import { features, routes } from '@app/consts';
import { Router } from "@angular/router";
import { FeatureService } from '@app/core/services/feature.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FormGeneratorDialogComponent } from '@app/shared/components/form-generator-dialog/form-generator-dialog.component';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { finalize } from 'rxjs/operators';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';
import { SortDescriptor } from '@progress/kendo-data-query';
import { WorkflowsAbsencesService } from '@app/core/services/workflows-absences/workflows-absences.service';

@Component({
  selector: 'app-pending-time-off-requests',
  templateUrl: './pending-time-off-requests.component.html',
  styleUrls: ['./pending-time-off-requests.component.scss']
})
export class PendingTimeOffRequestsComponent implements OnInit {
  @Input() employeeID: any;
  gridId: string = 'pendingTimeOffRequests';
  refreshView: boolean = true;
  public routes: typeof routes = routes;
  public features: typeof features = features;
  formId: string = 'frm_qK0FYWUEQe7FOz';
  dialogRef: MatDialogRef<FormGeneratorDialogComponent>;
  public columns: any[] = [
    { field: 'requestedOn', title: this.translate.instant('TimeOffRequest-RequestedOn'), localizationCode: 'TimeOffRequest-RequestedOn', type: 'dateTime' },
    { field: 'from', title: this.translate.instant('TimeOffRequest-From'), localizationCode: 'TimeOffRequest-From', type: 'date' },
    { field: 'to', title: this.translate.instant('TimeOffRequest-To'), localizationCode: 'TimeOffRequest-To', type: 'date' },
    { field: 'startTime', title: this.translate.instant('TimeOffRequest-StartTime'), localizationCode: 'TimeOffRequest-StartTime' },
    { field: 'endTime', title: this.translate.instant('TimeOffRequest-EndTime'), localizationCode: 'TimeOffRequest-EndTime' },
    { field: 'hours', title: this.translate.instant('TimeOffRequest-Hours'), localizationCode: 'TimeOffRequest-Hours' },
    { field: 'timeOffType', subField: 'name', title: this.translate.instant('TimeOffRequest-TimeOffType'), localizationCode: 'TimeOffRequest-TimeOffType' },
    { field: 'comments', title: this.translate.instant('TimeOffRequest-Comments'), localizationCode: 'TimeOffRequest-Comments', type: 'longText' },
  ];
  filterCategories: any[] = [
    {field: 'TimeOffType.Id', title: this.translate.instant('TimeOffRequest-TimeOffType'), dataType: 'SpecialLookup', lookupCode: 'TIME_OFF_TYPE'},
    { field: 'from', title: this.translate.instant('TimeOffRequest-From'), type: 'date', dataType: 'Date' },
    { field: 'to', title: this.translate.instant('TimeOffRequest-To'), type: 'date', dataType: 'Date' },
    { field: 'requestedOn', title: this.translate.instant('TimeOffRequest-RequestedOn'), dataType: 'Date' },
  ];
  sortableColumns: any[] = [
    { field: "requestedOn", sortValue: "requestedOn" },
    { field: "from", sortValue: "from" },
    { field: "to", sortValue: "to" },
    { field: "startTime", sortValue: "startTime" },
    { field: "endTime", sortValue: "endTime" },
    { field: "hours", sortValue: "hours" },
    { field: "timeOffType", sortValue: "timeOffType.name" },
  ];

  public gridDataResult: GridDataResult;
  public selectedPositions: any[] = [];
  isLoading: boolean;
  pageSize: number = 20;
  skip: number = 0;
  public searchFilterString: string;
  public searchValue: string;
  private getRequest: any;
  filterString: string;
  sort: SortDescriptor[] = [
    {
      field: 'requestedOn',
      dir: 'desc'
    }
  ];
  sortString: string = "requestedOn-desc";
  clearSelectedItems: boolean = false;

  constructor(
    featureService: FeatureService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private workflowsAbsencesService: WorkflowsAbsencesService,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    public router: Router,
  ) { }


  ngOnInit(): void {
    this.getPendingTimeOffRequests();
  }

  redirectOrgChart() {
    this.router.navigate([`${routes.REPORTS}${routes.ORG_CHART}`, { type: "organizations", isEditable: "true" }]);
  }
  
  navigateToOrganization(event) {
    // this.router.navigate([routes.ORGANIZATION_STRUCTURE]);
  }

  getPendingTimeOffRequests(): void {
    this.isLoading = true;

    let filter = `(requestedBy.id = "${this.employeeID}") AND (requestStatus.id = "trs_Pending")`;
    if (this.filterString) {
      if (filter) {
        filter = `${filter} AND ${this.filterString}`;
      }
      else {
        filter = `${this.filterString}`;
      }
    }

    this.getRequest = this.workflowsAbsencesService.getRequests(this.pageSize, this.skip, filter, this.sortString)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        res => {
          this.gridDataResult = {
            data: res.data,
            total: res.total,
          };
        }
      );
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take;
    this.getPendingTimeOffRequests();
  }

  filterCallback(filterString: string) {
    this.filterString = filterString;
    this.skip = 0;;
    this.getPendingTimeOffRequests();
  }

  gridStateChange(gridState: GridState) {
    if (this.pageSize !== gridState.pageSize) {
      this.pageSize = gridState.pageSize;
    }
    if (this.skip !== gridState.skip) {
      this.skip = gridState.skip;
    }
    if (this.sortString !== gridState.sortString) {
      this.sortString = gridState.sortString;
    }
    if (this.filterString !== gridState.filter) {
      this.filterString = gridState.filter;
      this.skip = 0;
    }

    this.getRequest.unsubscribe();
    this.getPendingTimeOffRequests();
  }
}

